export default __webpack_public_path__ + "/assets/fonts/la-solid-900.eot";